import React from 'react';
import {Subheading} from 'app/styles/heading';
import {mapsSelector} from 'app/helpers/helpers';
import {formatDateWithWeekday, formatTime} from 'app/helpers/dateHelpers';
import {TextWithLabelContainer, TextWithLabel} from 'app/components/textWithLabel/TextWithLabel';
import {Button} from '@fupa/fupa-uikit';
import styled from 'styled-components';

const Venue = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 1rem;
`;

const MatchInfo = ({info}) => {
  const facts = {
    kickoffTime: info.kickoff ? formatTime(info.kickoff) : '-',
    kickoff: info.kickoff ? formatDateWithWeekday(info.kickoff) : '-',
    venue: info.venue ? info.venue.name : '-',
    spectators: info.spectators !== null ? info.spectators : '-',
  };

  const mapsButton = info.venue ? (
    <Button justify='flex-end' label='Auf Karte anzeigen' text onClick={() => mapsSelector(info.venue)} />
  ) : null;

  return (
    <div>
      <Subheading variant='subheading2'>Spielinfo</Subheading>
      <TextWithLabelContainer>
        <TextWithLabel label='Zuschauer' data={facts.spectators} />
        <TextWithLabel label={`Anstoß um ${facts.kickoffTime} Uhr`} data={facts.kickoff} />
        <Venue>
          <TextWithLabel noPaddingBottom label='Stadion' data={facts.venue} />
          {mapsButton}
        </Venue>
      </TextWithLabelContainer>
    </div>
  );
};

export default MatchInfo;
